import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { accountService, authService, organizationService } from '../services'
import type { ICompany, IUser } from '../types'
import { mountStoreDevtool } from '../utils'
import { useNotificationStore } from './notification.store'
import { useTokenStore } from './token.store'
interface AuthStore {
  company: ICompany | null
  login: (payload: { email: string; password: string }) => Promise<void>
  logout: () => void
  refreshAuth: () => Promise<void>
  user: IUser | null
}

export const useAuthStore = create<AuthStore>()(
  devtools(
    (set) => ({
      company: null,
      user: null,

      login: async (payload) => {
        const { data } = await authService.login(payload)
        set({ user: data.user }, false, 'auth/login') // <-- label action
        useTokenStore.getState().setTokens(data)

        const company = await organizationService.fetchCompany()
        set({ company }, false, 'auth/fetchCompany')

        useNotificationStore.getInitialState().init()
      },

      logout: () => {
        useTokenStore.getState().clearTokens()
        set({ company: null, user: null }, false, 'auth/logout')
      },

      refreshAuth: async () => {
        const [auth, company] = await Promise.all([accountService.fetchProfile(), organizationService.fetchCompany()])
        set((state) => ({ ...state, company, user: auth.data }), false, 'auth/refreshAuth')

        useNotificationStore.getInitialState().init()
      },
    }),
    {
      name: 'AuthStore',
    },
  ),
)

if (import.meta.env.DEV) {
  mountStoreDevtool('auth.store', useAuthStore)
}
